<template>
  <portlet
      :icon="'fal fa-file'"
      :title="'Contracten'"
      :actionsBlock="true"
  >
    <template slot="actionsBlock">
    </template>
    <template slot="portletBody">
      <div class="d-flex justify-content-start mb-3">
        <button class="btn mr-2" :class="{'btn-sea-green': selectedStatus === 'in behandeling', 'btn-outline-sea-green': selectedStatus !== 'in behandeling'}" @click="selectedStatus = 'in behandeling'">In behandeling</button>
        <button class="btn" :class="{'btn-sea-green': selectedStatus === 'afgehandeld', 'btn-outline-sea-green': selectedStatus !== 'afgehandeld'}" @click="selectedStatus = 'afgehandeld'">Afgehandeld</button>
      </div>
      <datatables
          v-if="renderedComponent  && Can(rights.CONTRACTS_VIEW)"
          :tableClass="tableClass"
          tableID="contracts"
          :rows="filteredContractsDatatable"
          :columns="getColumns()"
          :tableInitOptions="tableInitOptions"
          routerLinkClass="dt-router-link"
          :deleteFunction="deleteContract"
          deleteClass="delete"
          :customFilters="customFilters"
      ></datatables>
      <p v-if="!filteredContractsDatatable.length" class="text-center">Geen contracten gevonden voor dit filter.</p>
    </template>
  </portlet>
</template>

<script>
import {mapGetters} from 'vuex';
import {dataTables} from '../../components/mixins/dataTables';
import {swalModals} from '../../components/mixins/swalModals.js';
import { Can } from '../../../permission/ability.js';
import { RIGHTS } from '../roles/rights.js';
import moment from "moment";
import axios from "axios";
import store from "../../store";
import Vue from "vue";
import { HANDLED_CONTRACT_SYNC_STATUS, syncHandledContractPlacement } from "@/utils/placementSync";
import { maskBsn } from "@/utils/bsn";

export default {
  mixins: [dataTables, swalModals],
  data() {
    return {
      users:[],
      customFilters: [],
      rights: '',
      selectedStatus: 'in behandeling', // Default filter status
    };
  },
  methods: {
    Can,
    deleteContract(contract) {
      this.swalDelete(`contract ${contract.firstName} ${contract.lastName}`).then(result => {
        if(result.value) {
          this.$store.dispatch('contracts/delete', contract.id);
          this.$toasted.global.successRequest({
            message: 'Contract verwijderd'
          });
        }
      });
    },
    resendContract(contract) {
      axios.post(this.$CLOUD_API + '/contracts/created', {contractId: contract.id});
      this.$toasted.global.successRequest({
        message: 'Contract opnieuw verzonden'
      });
    },
    async setContractToDone(contract) {
      const result = await this.$swal({
        title: 'Contract afhandelen?',
        html: `
          <p>Weet je zeker dat je dit contract wilt afhandelen?</p>
          <div style="background:#e6f7f7;border:1px solid #25b7bc;border-radius:4px;padding:10px 14px;margin-top:12px;text-align:left;font-size:14px;">
            <i class="fas fa-info-circle" style="color:#00A192;margin-right:6px;"></i>
            <strong>Let op:</strong> De medewerker wordt automatisch geplaatst bij het betreffende bedrijf op basis van de contractgegevens.
          </div>
        `,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Ja, afhandelen & plaatsen',
        cancelButtonText: 'Annuleren',
        reverseButtons: true
      });
      if (!result.value) return;

      const placement = await this.handleContract(contract);

      if (!placement) {
        return;
      }

      this.announceHourAppSync(await syncHandledContractPlacement(this.$store.dispatch, {
        ApiClient: Vue.prototype.$ApiClient,
        departments: this.$store.getters.getUserData.departments,
        placement,
        candidate: this.getCandidate(contract.candidateId),
        customer: this.getCustomer(contract.customerId),
      }));
    },
    async handleContract(contract) {
      const userData = this.$store.getters.getUserData;

      this.$store.commit('setLoading', true);

      try {
        await this.$store.dispatch('contracts/patch', {
          id: contract.id,
          status: 'afgehandeld',
          status_to_finished: new Date()
        });

        const creator = this.getUsers.find(u => u.id === contract.created_by);
        let startDate = contract.startDate;
        if (startDate && typeof startDate.toDate === 'function') {
          startDate = moment(startDate.toDate()).format('YYYY-MM-DD');
        }

        const placement = {
          candidateId: contract.candidateId,
          customerId: contract.customerId,
          hourlyWage: contract.hourlyWage,
          startDate: startDate,
          placedBy: creator ? [{ id: creator.id, displayName: creator.displayName }] : [],
          createdBy: userData,
          department: userData.selectedDepartment
        };
        const placementId = await this.$store.dispatch('placements/set', placement);

        this.$toasted.global.successRequest({
          message: 'Contract afgehandeld en medewerker geplaatst'
        });

        return {...placement, id: placementId};
      } catch (handlingFailed) {
        this.$toasted.global.failedRequest({
          message: 'Contract afhandelen is mislukt, controleer of de plaatsing is aangemaakt'
        });

        return null;
      } finally {
        this.$store.commit('setLoading', false);
      }
    },
    announceHourAppSync(sync) {
      if (sync.status === HANDLED_CONTRACT_SYNC_STATUS.SYNCED) {
        this.$toasted.global.successRequest({
          message: 'Plaatsing gesynced met de urenapp'
        });
      }

      if (sync.status === HANDLED_CONTRACT_SYNC_STATUS.FAILED) {
        this.$toasted.global.failedRequest({message: sync.message});
      }
    },
    getColumns() {
      let self = this;
      const daysOfWeek = ['maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag', 'zondag'];
      return [
        {name: 'Status', data: null, visible: true, searchable: true, responsivePriority: 2,render: (data) => data.status ? data.status : ''},
        {name: 'Dagen open', data: null, visible: true, searchable: false, responsivePriority: 2,render: (data) => {
            if (data.status === 'in behandeling') {
              return moment().diff(moment(data.created_at), 'days');
            } else {
              return moment(data.status_to_finished).diff(moment(data.created_at), 'days');
            }
          }
        },
        {name: 'Klant', data: null, visible: true, searchable: true, responsivePriority: 2,render: (data) => {
            if (!data.customerId) return '';
            const customer = self.getCustomer(data.customerId);
            return customer ? customer.name : '';
          }
        },
        {name: 'Voornaam', data: null, visible: true, searchable: true,responsivePriority: 2, render: (data) => data.firstName ? data.firstName : ''},
        {name: 'Achternaam', data: null, visible: true, searchable: true, responsivePriority: 2,render: (data) => data.lastName ? data.lastName : ''},
        {name: 'BSN', data: null, visible: true, searchable: true,responsivePriority: 2, render: (data) => Can(RIGHTS.IS_ADMIN) ? (data.bsn || '') : maskBsn(data.bsn)},


        {name: 'Diensten', data: null, visible: true, searchable: true,responsivePriority: 2, render: (data) => data.shifts ? data.shifts : ''},
        {name: 'Toeslag', data: null, visible: false, searchable: true,responsivePriority: 2, render: (data) => data.shiftAddition ? data.shiftAddition : ''},
        {name: 'Functie', data: null, visible: true, searchable: true,responsivePriority: 2, render: (data) => data.function ? data.function : ''},
        {name: 'Startdatum', data: null, visible: true, searchable: true,responsivePriority: 2, render: (data, type) => {
            if (!data.startDate) return type === 'sort' || type === 'type' ? 0 : '';
            const date = moment(data.startDate.toDate());
            if (type === 'sort' || type === 'type') return date.valueOf();
            return date.format('DD-MM-YYYY');
          }
        },
        {name: 'Schaal', data: null, visible: false, searchable: true,responsivePriority: 2, render: (data) => data.scale ? data.scale : ''},
        {name: 'Trede', data: null, visible: false, searchable: true, responsivePriority: 2,render: (data) => data.step ? data.step : ''},
        {name: 'Uurloon', data: null, visible: false, searchable: true,responsivePriority: 2, render: (data) => data.hourlyWage ? data.hourlyWage : ''},
        {name: 'Factor', data: null, visible: false, searchable: true,responsivePriority: 2, render: (data) => data.factor ? data.factor : ''},
        {name: 'Werktijden', data: null, visible: true, searchable: true,responsivePriority: 6, render: (data) => {
            if (!data.workingHours) return '';
            let workingHoursString = '';
            daysOfWeek.forEach(day => {
              if (data.workingHours[day]) {
                let value = '';
                if (data.workingHours[day].notWorking) {
                  value = 'Niet werkzaam';
                } else {
                  value = `${data.workingHours[day].start} - ${data.workingHours[day].end}`;
                }
                workingHoursString += `<div style="display: flex; justify-content: space-between;"><span class="mr-5">${day}</span><span>${value}</span></div>`;
              }
            });
            return workingHoursString;
          }
        },
        {name: 'Betaalfrequentie', data: null, visible: true, searchable: true, responsivePriority: 2,render: (data) => data.paymentFrequency ? data.paymentFrequency : ''},
        {name: 'WKR', data: null, visible: true, searchable: true, render: (data) => data.wkr ? data.wkr : ''},
        {name: 'Gemaakt door', data: null, visible: true, searchable: true, responsivePriority: 2, render: (data) => {

            const user = self.getUsers.find(u => u.id === data.created_by);
            return user ? user.displayName : '';
          }
        },
        {
          data: null, name: 'Opties', orderable: false, responsivePriority: 2,
          render(data) {
            var options = '';


            if(Can(RIGHTS.IS_ADMIN) || Can(RIGHTS.CONTRACTS_DELETE)) {
              options += '<a class="delete action-icon" data-id="' + data.id + '"><i title="Verwijder" class="far fa-trash-alt delete"></i></a>';
            }



            if (data.status === 'in behandeling') {
              options += '<a class="set-to-done action-icon" data-id="' + data.id + '"><i title="Afhandelen" class="far fa-check-circle"></i></a>';
              options += '<a class="resend-contract action-icon" data-id="' + data.id + '"><i title="Opnieuw verzenden" class="far fa-paper-plane"></i></a>';
            }

            return options;
          }
        }
      ]
    }
  },
  computed: {
    ...mapGetters('contracts', ['getContractsDatatable']),
    ...mapGetters('customers', ['getCustomer']),
    ...mapGetters('candidates', ['getCandidate']),
    ...mapGetters('users', ['getUsers']),
    filteredContractsDatatable() {
      return this.getContractsDatatable.filter(contract => contract.status === this.selectedStatus);
    }
  },
  async created() {
    this.rights = RIGHTS;

      // this.$store.commit('setLoading',true)
      await   store.dispatch('users/getAllUsers', {ApiClient: Vue.prototype.$ApiClient, departments: this.$store.getters.getUserData.departments}).then((res) => {
        if (res.status === 200) {

          this.users = res.data.users.filter(user => user.hasOwnProperty('email'));
          this.$store.commit('users/setUsers', this.users)
          this.nextPageToken = res.nextToken;
          // this.$store.commit('setLoading',false)
          this.renderedComponent = false;
          this.renderedComponent = true;
        }
      }).catch((err) => {
        this.$store.commit('setLoading',false)

      });

      this.$store.commit('setLoading',false)

    $(document).on('click.contracts', '.resend-contract', (e) => {
      const contractId = e.currentTarget.dataset.id;
      const contract = this.getContractsDatatable.find(c => c.id === contractId);
      this.resendContract(contract);
    });

    $(document).on('click.contracts', '.set-to-done', (e) => {
      const contractId = e.currentTarget.dataset.id;
      const contract = this.getContractsDatatable.find(c => c.id === contractId);
      this.setContractToDone(contract);
    });
  },
  beforeDestroy() {
    $(document).off('click.contracts');
  }
};
</script>
<style lang="scss" scoped>
.btn-sea-green {
  background-color: #00A192;
  border-color: #00A192;
  color: #fff;

  &:hover {
    background-color: darken(#00A192, 10%);
    border-color: darken(#00A192, 10%);
  }
}

.btn-outline-sea-green {
  color: #00A192;
  border-color: #00A192;
  background-color: transparent;

  &:hover {
    background-color: #00A192;
    color: #fff;
  }
}
</style>